import React, {Component} from "react";
import DynamicScenarioMap from "./DynamicScenarioMap";
import LoadingSpinner from '../Utils/LoadingSpinner';

export class DynamicScenarioEditor extends Component {

    // State of this component
    state = {
        start_lla: this.props.start_lla,
        finish_lla: this.props.finish_lla,
        loading: false, // will be true when ajax request is running
    };


    handleCreateScenario = () => {
        console.log("Creating route");
        console.log("from", this.state.start_lla);
        console.log("to", this.state.finish_lla);

        this.setState({loading:true}, () => {

                const scenario = {
                    type: 'dynamic',
                    start_lla: this.state.start_lla,
                    finish_lla: this.state.finish_lla,
                };
                this.props.simGps.submitScenario( this.props.uuid, scenario ,
                    (success, result) => {
                        if( success ){
                            console.log('StaticScenarioEditor update result ' + JSON.stringify(result));
                            this.setState({loading: false});
                            this.props.onUpdated();
                        }else{
                            this.setState({loading: false});
                            console.log('Error talking to simulation data server' + result);
                        }
                    });
            }
        );
    };

    // Called by StaticScenarioMap when pin location changes
    onLlaChange = (start_lla, finish_lla) => {
        this.setState({
            start_lla: start_lla,
            finish_lla: finish_lla
            }
        );
    };

    render() {
        if( this.state.loading) {
            return ( <LoadingSpinner text="Creating dynamic route ..." /> );
        } else {
            return (
                <div>
                    From : {this.state.start_lla[0]}, Lon: {this.state.start_lla[1]}
                    To : {this.state.finish_lla[0]}, Lon: {this.state.finish_lla[1]}
                    <button onClick={this.handleCreateScenario}>Create Scenario</button>
                    <DynamicScenarioMap
                        start_lla={this.props.start_lla}
                        finish_lla={this.props.finish_lla}
                        onLlaChange={this.onLlaChange}
                    />
                </div>
            );
        }
    }
}

export default DynamicScenarioEditor;
